
import SplashPage from '@scoir/splash-page'

import artwork from './Splash-Inbox.png'

const InboxSplashPage = () => {
  return (
    <SplashPage
      title={
        <span>
          Connect with
          <br />
          Colleges
        </span>
      }
      subtitle={
        <span>
          Discover the best-fit
          <br />
          Colleges for you.
        </span>
      }
      body="Once you Follow a college, you can receive messages from that college based on your interests, academic focus, class year, and more."
      artwork={artwork}
      artworkProps={{ alt: 'Sign in to connect with colleges' }}
      buttonText="Discover Colleges"
      buttonHref="/student/discover/search"
    />
  )
}

export default InboxSplashPage
